import React, {memo, useCallback, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {HOTEL_CARD_MAX_WIDTH} from 'components/HotelCardMobile'
import useShowOverlay from 'hooks/useShowOverlay/useShowOverlay'
import {getLanguageCode} from 'modules/meta/selectors'
import {OverlayType} from 'modules/overlay/types'
import {getReviewClosestToLength} from 'utils/trustPilot/trustPilot'

import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {cssTheme} from '@vio/atlas/src/themes'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'
import {useGetReviewsQuery} from '@vio/core/src/trustpilotWidget/services/trustpilotApi'

import {TrustpilotReviewItem} from '../TrustpilotReviewItem'

const CardWrapper = styled.div`
  max-width: ${HOTEL_CARD_MAX_WIDTH}px;
  margin: 0 auto;
  margin-bottom: ${cssTheme.layout.spacing.s500};
`
const TrustpilotMobileBannerComponent = () => {
  const dispatch = useDispatch()
  const showOverlay = useShowOverlay()
  const {isMobile, isDesktopXs} = useDeviceLayout()
  const {shell} = useBrandCapabilities()
  const languageCode = useSelector(getLanguageCode)

  const isFeatureDisabled = (!isMobile && !isDesktopXs) || !shell?.hasTrustpilot

  const {data: reviewsData} = useGetReviewsQuery(
    {
      language: languageCode
    },
    {
      skip: isFeatureDisabled
    }
  )
  const selectedReview = useMemo(() => {
    return getReviewClosestToLength(reviewsData?.reviews)
  }, [reviewsData])

  const onOpenBottomSheet = useCallback(() => {
    showOverlay({type: OverlayType.TrustpilotBottomSheet})
    dispatch(
      trackEvent({
        category: Category.User,
        entity: Entity.TrustpilotBanner,
        action: Action.Clicked
      })
    )
  }, [dispatch, showOverlay])

  if (isFeatureDisabled || !selectedReview?.id) return null

  return (
    <CardWrapper>
      <TrustpilotReviewItem
        review={selectedReview}
        isReviewCard
        onClick={onOpenBottomSheet}
      />
    </CardWrapper>
  )
}

export const TrustpilotMobileBanner = memo(TrustpilotMobileBannerComponent)
